import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  { path: '/', name: 'home', component: () => import('./pages/Home.vue') },
  { path: '/share/:key', name: 'share', component: () => import('./pages/Gallery.vue'), props: true },
  { path: '/s/:key', name: 'share-short', component: () => import('./pages/Gallery.vue'), props: true },
  {
    path: '/share/:key/download',
    name: 'share-download',
    component: () => import('./pages/Gallery.vue'),
    props: (route) => ({ key: route.params.key, autoDownload: true }),
  },
  { path: '/:pathMatch(.*)*', name: 'not-found', component: () => import('./pages/NotFound.vue') },
]

export const router = createRouter({
  history: createWebHistory(),
  routes,
})
